<section class="become">
    <span class="text">

        <h2>Torne-se um doador neste Dia de Doar</h2>
        <p>
            O Dia de Doar incentiva doações de todos os tipos! A primeira coisa a fazer é reunir sua rede. Doar é muito
            mais
            impactante (e divertido) quando é feito em grupo! Pense nos seus grupos de WhatsApp, em espaços
            colaborativos do
            seu
            bairro, nos grupos de Facebook da sua cidade ou na intranet da sua empresa…
        </p>
        <p>

            Em seguida, convide quem se interessou a construir junto com você estratégias para conscientizar a
            comunidade
            sobre
            a
            causa que estão lutando. Pode ser uma causa local ou uma colaboração para resolver um problema da
            comunidade.
        </p>
    </span>
    <section class="cards">
        <mat-card class="action-card">
            <a class="card-link" [routerLink]="['/inscreva-se']" matRipple>
                <mat-card-content>
                    <p>Encontre organizações na sua região pelo Mapa da Generosidade!</p>
                    <!-- <img src="assets/mascotes/como-comecou.png" alt=""> -->
                </mat-card-content>
            </a>
        </mat-card>
        <mat-card class="action-card">
            <a class="card-link" [routerLink]="['/inspire-se']" matRipple>
                <mat-card-content>
                    <p>Encontre histórias inspiradoras</p>
                </mat-card-content>
            </a>
        </mat-card>
        <mat-card class="action-card">
            <a class="card-link" href="/inscreva-se" (click)="openSameTab($event, '/inscreva-se')" matRipple>
                <mat-card-content>
                    <p>Compartilhe sua iniciativa</p>
                </mat-card-content>
            </a>
        </mat-card>
        <mat-card class="action-card">
            <a class="card-link" href="https://forms.gle/R3UNT3YpfZjPdx6p8" target="_blank" rel="noopener" matRipple>
                <mat-card-content>
                    <p>Seja um voluntário digital do Dia de Doar</p>
                </mat-card-content>
            </a>
        </mat-card>
    </section>
</section>